import _ from 'lodash'

/**
 * Cleans a dataset series so that the value, row and column specifications don't
 * mention the calendar field we're filtering on.  If one of them did, it would
 * restrict the datasetSeries in a way the user probably didn't intend. (e.g. there
 * might only be datasetSeries for a single period instead of all periods).
 */
function cleanDatasetSeries(datasetSeries) {
	_.each(['value', 'row', 'column'], (name) => {
		if (_.get(datasetSeries[name], 'fieldId') == datasetSeries.calendarFieldId) {
			delete datasetSeries[name]
		}
	})
}

export default cleanDatasetSeries

cleanDatasetSeries.__filename__ = 'datasets/clean-dataset-series.js'
